import api from "../../utils/axiosInstance";

export const fetchBrowseTutorDataRequest = () => ({
    type: "FETCH_BROWSE_TUTOR_DATA_REQUEST",
});

export const fetchBrowseTutorDataSuccess = (data) => ({
    type: "FETCH_BROWSE_TUTOR_DATA_SUCCESS",
    payload: data,
});

export const fetchBrowseTutorDataFailure = (error) => ({
    type: "FETCH_BROWSE_TUTOR_DATA_FAILURE",
    payload: error,
});

export const getBrowseTutorData = (values) => async (dispatch) => {
    dispatch(fetchBrowseTutorDataRequest());
    try {
        const authToken = localStorage.getItem('student-token');

        let response = await api.post(`/api/web/web-search-tutor`, values, {
            headers: {
                "x-auth-token": authToken,
                "Content-Type": "application/json",
            },
        });

        const data = response.data;
        dispatch(fetchBrowseTutorDataSuccess(data));
    } catch (error) {
        dispatch(fetchBrowseTutorDataFailure(error.message));
    }
};

export const fetchBrowseTutorDetailRequest = () => ({
    type: "FETCH_BROWSE_TUTOR_DETAIL_REQUEST",
});

export const fetchBrowseTutorDetailSuccess = (data) => ({
    type: "FETCH_BROWSE_TUTOR_DETAIL_SUCCESS",
    payload: data,
});

export const fetchBrowseTutorDetailFailure = (error) => ({
    type: "FETCH_BROWSE_TUTOR_DETAIL_FAILURE",
    payload: error,
});

export const getBrowseTutorDetail = (id) => async (dispatch) => {
    dispatch(fetchBrowseTutorDetailRequest());
    try {
        const authToken = localStorage.getItem('student-token');

        let response = await api.get(`/api/student/browse-tutor/search-tutor-view?tutor_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchBrowseTutorDetailSuccess(desired_data));
    } catch (error) {
        dispatch(fetchBrowseTutorDetailFailure(error.message));
    }
}

export const fetchGroupCourseListRequest = () => ({
    type: "FETCH_GROUP_COURSE_LIST_REQUEST",
});

export const fetchGroupCourseListSuccess = (data) => ({
    type: "FETCH_GROUP_COURSE_LIST_SUCCESS",
    payload: data,
});

export const fetchGroupCourseListFailure = (error) => ({
    type: "FETCH_GROUP_COURSE_LIST_FAILURE",
    payload: error,
});

export const getGroupCourseList = (id) => async (dispatch) => {
    dispatch(fetchGroupCourseListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/browse-tutor/get-group-course-list-by-tutor?tutor_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchGroupCourseListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchGroupCourseListFailure(error.message));
    }
}

export const fetchGroupCourseBatchListRequest = () => ({
    type: "FETCH_GROUP_COURSE_BATCH_LIST_REQUEST",
});

export const fetchGroupCourseBatchListSuccess = (data) => ({
    type: "FETCH_GROUP_COURSE_BATCH_LIST_SUCCESS",
    payload: data,
});

export const fetchGroupCourseBatchListFailure = (error) => ({
    type: "FETCH_GROUP_COURSE_BATCH_LIST_FAILURE",
    payload: error,
});

export const getGroupCourseBatchList = (id) => async (dispatch) => {
    dispatch(fetchGroupCourseBatchListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/browse-tutor/get-group-course-batch-list-by-tutor?course_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchGroupCourseBatchListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchGroupCourseBatchListFailure(error.message));
    }
}

export const fetchGroupCourseBatchSessionListRequest = () => ({
    type: "FETCH_GROUP_COURSE_BATCH_SESSION_LIST_REQUEST",
});

export const fetchGroupCourseBatchSessionListSuccess = (data) => ({
    type: "FETCH_GROUP_COURSE_BATCH_SESSION_LIST_SUCCESS",
    payload: data,
});

export const fetchGroupCourseBatchSessionListFailure = (error) => ({
    type: "FETCH_GROUP_COURSE_BATCH_SESSION_LIST_FAILURE",
    payload: error,
});

export const getGroupCourseBatchSessionList = (id) => async (dispatch) => {
    dispatch(fetchGroupCourseBatchSessionListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/browse-tutor/get-group-course-batch-session-list-by-tutor?batch_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchGroupCourseBatchSessionListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchGroupCourseBatchSessionListFailure(error.message));
    }
}

export const fetchCategoryOnTuotrIdListRequest = () => ({
    type: "FETCH_CATEGORY_ON_TUTOR_LIST_REQUEST",
});

export const fetchCategoryOnTuotrIdListSuccess = (data) => ({
    type: "FETCH_CATEGORY_ON_TUTOR_LIST_SUCCESS",
    payload: data,
});

export const fetchCategoryOnTuotrIdListFailure = (error) => ({
    type: "FETCH_CATEGORY_ON_TUTOR_LIST_FAILURE",
    payload: error,
});

export const getCategoryOnTuotrIdList = (id) => async (dispatch) => {
    dispatch(fetchCategoryOnTuotrIdListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/category-on-tutor-id?tutor_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchCategoryOnTuotrIdListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchCategoryOnTuotrIdListFailure(error.message));
    }
}

export const fetchSubCategoryOnTuotrIdListRequest = () => ({
    type: "FETCH_SUB_CATEGORY_ON_TUTOR_LIST_REQUEST",
});

export const fetchSubCategoryOnTuotrIdListSuccess = (data) => ({
    type: "FETCH_SUB_CATEGORY_ON_TUTOR_LIST_SUCCESS",
    payload: data,
});

export const fetchSubCategoryOnTuotrIdListFailure = (error) => ({
    type: "FETCH_SUB_CATEGORY_ON_TUTOR_LIST_FAILURE",
    payload: error,
});

export const getSubCategoryOnTuotrIdList = (id, tutor_id) => async (dispatch) => {
    dispatch(fetchSubCategoryOnTuotrIdListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/sub-category-one-to-one?category_id=${id}&tutor_id=${tutor_id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchSubCategoryOnTuotrIdListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchSubCategoryOnTuotrIdListFailure(error.message));
    }
}

export const fetchChildCategoryOnTuotrIdListRequest = () => ({
    type: "FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_REQUEST",
});

export const fetchChildCategoryOnTuotrIdListSuccess = (data) => ({
    type: "FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_SUCCESS",
    payload: data,
});

export const fetchChildCategoryOnTuotrIdListFailure = (error) => ({
    type: "FETCH_CHILD_CATEGORY_ON_TUTOR_LIST_FAILURE",
    payload: error,
});

export const getChildCategoryOnTuotrIdList = (category_id, sub_category_id, tutor_id) => async (dispatch) => {
    dispatch(fetchChildCategoryOnTuotrIdListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/child-category-one-to-one?category_id=${category_id}&sub_category_id=${sub_category_id}&tutor_id=${tutor_id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchChildCategoryOnTuotrIdListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchChildCategoryOnTuotrIdListFailure(error.message));
    }
}

export const fetchStudentRequestTutorListRequest = () => ({
    type: "FETCH_REQUEST_TUTOR_LIST_REQUEST",
});

export const fetchStudentRequestTutorListSuccess = (data) => ({
    type: "FETCH_REQUEST_TUTOR_LIST_SUCCESS",
    payload: data,
});

export const fetchStudentRequestTutorListFailure = (error) => ({
    type: "FETCH_REQUEST_TUTOR_LIST_FAILURE",
    payload: error,
});

export const getStudentRequestTutorList = () => async (dispatch) => {
    dispatch(fetchStudentRequestTutorListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/request-tutor/new-request`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentRequestTutorListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentRequestTutorListFailure(error.message));
    }
}

export const fetchStudentApprovedTutorListRequest = () => ({
    type: "FETCH_APPROVED_TUTOR_LIST_REQUEST",
});

export const fetchStudentApprovedTutorListSuccess = (data) => ({
    type: "FETCH_APPROVED_TUTOR_LIST_SUCCESS",
    payload: data,
});

export const fetchStudentApprovedTutorListFailure = (error) => ({
    type: "FETCH_APPROVED_TUTOR_LIST_FAILURE",
    payload: error,
});

export const getStudentApprovedTutorList = () => async (dispatch) => {
    dispatch(fetchStudentApprovedTutorListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/request-tutor/approved-list`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentApprovedTutorListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentApprovedTutorListFailure(error.message));
    }
}

export const fetchStudentRequestTutorDetailRequest = () => ({
    type: "FETCH_REQUEST_TUTOR_DETAIL_REQUEST",
});

export const fetchStudentRequestTutorDetailSuccess = (data) => ({
    type: "FETCH_REQUEST_TUTOR_DETAIL_SUCCESS",
    payload: data,
});

export const fetchStudentRequestTutorDetailFailure = (error) => ({
    type: "FETCH_REQUEST_TUTOR_DETAIL_FAILURE",
    payload: error,
});

export const getStudentRequestTutorDetail = (id) => async (dispatch) => {
    dispatch(fetchStudentRequestTutorDetailRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/request-tutor/new-request-details?request_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentRequestTutorDetailSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentRequestTutorDetailFailure(error.message));
    }
}

export const fetchStudentApprovedTutorDetailRequest = () => ({
    type: "FETCH_APPROVED_TUTOR_DETAIL_REQUEST",
});

export const fetchStudentApprovedTutorDetailSuccess = (data) => ({
    type: "FETCH_APPROVED_TUTOR_DETAIL_SUCCESS",
    payload: data,
});

export const fetchStudentApprovedTutorDetailFailure = (error) => ({
    type: "FETCH_APPROVED_TUTOR_DETAIL_FAILURE",
    payload: error,
});

export const getStudentApprovedTutorDetail = (id) => async (dispatch) => {
    console.log('in action', id)
    dispatch(fetchStudentApprovedTutorDetailRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/request-tutor/approved-list-details?request_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentApprovedTutorDetailSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentApprovedTutorDetailFailure(error.message));
    }
}

export const fetchStudentMyBookingsListRequest = () => ({
    type: "FETCH_MY_BOOKINGS_LIST_REQUEST",
});

export const fetchStudentMyBookingsListSuccess = (data) => ({
    type: "FETCH_MY_BOOKINGS_LIST_SUCCESS",
    payload: data,
});

export const fetchStudentMyBookingsListFailure = (error) => ({
    type: "FETCH_MY_BOOKINGS_LIST_FAILURE",
    payload: error,
});

export const getStudentMyBookingsList = () => async (dispatch) => {
    dispatch(fetchStudentMyBookingsListRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-booking/summery`, {
            headers: {
                "x-auth-token": authToken,
            },
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentMyBookingsListSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentMyBookingsListFailure(error.message));
    }
}

export const fetchStudentStudyMaterialImageListDataRequest = (query) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_REQUEST",
});

export const fetchStudentStudyMaterialImageListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentStudyMaterialImageListDataFailure = (error) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_IMAGE_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentStudyMaterialImageListData = (query) => async (dispatch) => {
    dispatch(fetchStudentStudyMaterialImageListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/study-material/image-lessons`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentStudyMaterialImageListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentStudyMaterialImageListDataFailure(error.message));
    }
}

export const fetchStudentStudyMaterialPdfListDataRequest = () => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_REQUEST",
});

export const fetchStudentStudyMaterialPdfListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentStudyMaterialPdfListDataFailure = (error) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PDF_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentStudyMaterialPdfListData = (query) => async (dispatch) => {
    dispatch(fetchStudentStudyMaterialPdfListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/study-material/pdf-lessons`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentStudyMaterialPdfListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentStudyMaterialPdfListDataFailure(error.message));
    }
}

export const fetchStudentStudyMaterialDocListDataRequest = () => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_REQUEST",
});

export const fetchStudentStudyMaterialDocListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentStudyMaterialDocListDataFailure = (error) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_DOC_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentStudyMaterialDocListData = () => async (dispatch) => {

    dispatch(fetchStudentStudyMaterialDocListDataRequest());

    try {

        const authToken = localStorage.getItem('student-token');

        let response = await api.get(
            `/api/student/study-material/doc-lessons`,
            {
                headers: {
                    "x-auth-token": authToken,
                }
            }
        );

         console.log("DOC API RESPONSE =>", response.data);

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentStudyMaterialDocListDataSuccess(desired_data));

    } catch (error) {

        dispatch(
            fetchStudentStudyMaterialDocListDataFailure(error.message)
        );
    }
};

export const fetchStudentStudyMaterialPptListDataRequest = () => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_REQUEST",
});

export const fetchStudentStudyMaterialPptListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentStudyMaterialPptListDataFailure = (error) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_PPT_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentStudyMaterialPptListData = () => async (dispatch) => {

    dispatch(fetchStudentStudyMaterialPptListDataRequest());

    try {

        const authToken = localStorage.getItem('student-token');

        let response = await api.get(
            `/api/student/study-material/ppt-lessons`,
            {
                headers: {
                    "x-auth-token": authToken,
                }
            }
        );

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentStudyMaterialPptListDataSuccess(desired_data));

    } catch (error) {

        dispatch(
            fetchStudentStudyMaterialPptListDataFailure(error.message)
        );
    }
};

export const fetchStudentStudyMaterialVideoListDataRequest = () => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_REQUEST",
});

export const fetchStudentStudyMaterialVideoListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentStudyMaterialVideoListDataFailure = (error) => ({
    type: "FETCH_STUDENT_STUDY_MATERIAL_VIDEO_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentStudyMaterialVideoListData = () => async (dispatch) => {
    dispatch(fetchStudentStudyMaterialVideoListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/study-material/video-lessons`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentStudyMaterialVideoListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentStudyMaterialVideoListDataFailure(error.message));
    }
}

export const fetchStudentQueriesListDataRequest = () => ({
    type: "FETCH_STUDENT_QUERY_LIST_DATA_REQUEST",
});

export const fetchStudentQueriesListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_QUERY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentQueriesListDataFailure = (error) => ({
    type: "FETCH_STUDENT_QUERY_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentQueriesListData = () => async (dispatch) => {
    dispatch(fetchStudentQueriesListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/study-material/my-query`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentQueriesListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentQueriesListDataFailure(error.message));
    }
}

export const fetchStudentQueriesDetailDataRequest = () => ({
    type: "FETCH_STUDENT_QUERIES_DETAIL_DATA_REQUEST",
});

export const fetchStudentQueriesDetailDataSuccess = (data) => ({
    type: "FETCH_STUDENT_QUERIES_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentQueriesDetailDataFailure = (error) => ({
    type: "FETCH_STUDENT_QUERIES_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getStudentQueriesDetailData = (id) => async (dispatch) => {
    dispatch(fetchStudentQueriesDetailDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/study-material/my-query-detials?query_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentQueriesDetailDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentQueriesDetailDataFailure(error.message));
    }
}

export const fetchStudentMyTutorOneToOneListDataRequest = () => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_REQUEST",
});

export const fetchStudentMyTutorOneToOneListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentMyTutorOneToOneListDataFailure = (error) => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_ONE_TO_ONE_DATA_FAILURE",
    payload: error,
});

export const getStudentMyTutorOneToOneListData = (id) => async (dispatch) => {
    dispatch(fetchStudentMyTutorOneToOneListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?teaching_type=0`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentMyTutorOneToOneListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentMyTutorOneToOneListDataFailure(error.message));
    }
}

export const fetchStudentMyTutorGroupListDataRequest = () => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_REQUEST",
});

export const fetchStudentMyTutorGroupListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentMyTutorGroupListDataFailure = (error) => ({
    type: "FETCH_STUDENT_MY_TUTOR_LIST_GROUP_DATA_FAILURE",
    payload: error,
});

export const getStudentMyTutorGroupListData = (id) => async (dispatch) => {
    dispatch(fetchStudentMyTutorGroupListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?teaching_type=1`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentMyTutorGroupListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentMyTutorGroupListDataFailure(error.message));
    }
}

export const fetchStudentBookedTutorDetailDataRequest = () => ({
    type: "FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_REQUEST",
});

export const fetchStudentBookedTutorDetailDataSuccess = (data) => ({
    type: "FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentBookedTutorDetailDataFailure = (error) => ({
    type: "FETCH_STUDENT_BOOKED_TUTOR_DETAIL_DATA_FAILURE",
    payload: error,
});

export const getStudentBookedTutorDetailData = (id) => async (dispatch) => {
    dispatch(fetchStudentBookedTutorDetailDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-booking/summery-detail?booking_id=${id}`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentBookedTutorDetailDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentBookedTutorDetailDataFailure(error.message));
    }
}

export const fetchStudentOnlineLectureOneToOneTodayListDataRequest = () => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_REQUEST",
});

export const fetchStudentOnlineLectureOneToOneTodayListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentOnlineLectureOneToOneTodayListDataFailure = (error) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_TODAY_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentOnlineLectureOneToOneTodayListData = (id) => async (dispatch) => {
    dispatch(fetchStudentOnlineLectureOneToOneTodayListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?filter=today&teaching_type=0`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentOnlineLectureOneToOneTodayListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentOnlineLectureOneToOneTodayListDataFailure(error.message));
    }
}

export const fetchStudentOnlineLectureGroupTodayListDataRequest = () => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_REQUEST",
});

export const fetchStudentOnlineLectureGroupTodayListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentOnlineLectureGroupTodayListDataFailure = (error) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_TODAY_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentOnlineLectureGroupTodayListData = (id) => async (dispatch) => {
    dispatch(fetchStudentOnlineLectureGroupTodayListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?filter=today&teaching_type=1`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentOnlineLectureGroupTodayListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentOnlineLectureGroupTodayListDataFailure(error.message));
    }
}

export const fetchStudentOnlineLectureOneToOneMonthlyListDataRequest = () => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_REQUEST",
});

export const fetchStudentOnlineLectureOneToOneMonthlyListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentOnlineLectureOneToOneMonthlyListDataFailure = (error) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_ONE_TO_ONE_MONTHLY_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentOnlineLectureOneToOneMonthlyListData = (id) => async (dispatch) => {
    dispatch(fetchStudentOnlineLectureOneToOneMonthlyListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?filter=current_month&teaching_type=0`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentOnlineLectureOneToOneMonthlyListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentOnlineLectureOneToOneMonthlyListDataFailure(error.message));
    }
}

export const fetchStudentOnlineLectureGroupMonthlyListDataRequest = () => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_REQUEST",
});

export const fetchStudentOnlineLectureGroupMonthlyListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentOnlineLectureGroupMonthlyListDataFailure = (error) => ({
    type: "FETCH_STUDENT_ONLINE_LECTURE_GROUP_MONTHLY_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentOnlineLectureGroupMonthlyListData = (id) => async (dispatch) => {
    dispatch(fetchStudentOnlineLectureGroupMonthlyListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/my-tutor/booked-tutor-list?filter=current_month&teaching_type=1`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentOnlineLectureGroupMonthlyListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentOnlineLectureGroupMonthlyListDataFailure(error.message));
    }
}

export const fetchStudentUpcomingAssListDataRequest = () => ({
    type: "FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_REQUEST",
});

export const fetchStudentUpcomingAssListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentUpcomingAssListDataFailure = (error) => ({
    type: "FETCH_STUDENT_UPCOMING_ASS_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentUpcomingAssListData = () => async (dispatch) => {
    dispatch(fetchStudentUpcomingAssListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/assessment/future`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentUpcomingAssListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentUpcomingAssListDataFailure(error.message));
    }
}

export const fetchStudentCompletedAssListDataRequest = () => ({
    type: "FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_REQUEST",
});

export const fetchStudentCompletedAssListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentCompletedAssListDataFailure = (error) => ({
    type: "FETCH_STUDENT_COMPLETED_ASS_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentCompletedAssListData = () => async (dispatch) => {
    dispatch(fetchStudentCompletedAssListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/assessment/completed`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentCompletedAssListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentCompletedAssListDataFailure(error.message));
    }
}

export const fetchStudentNotificationListDataRequest = () => ({
    type: "FETCH_STUDENT_NOTIFICATION_LIST_DATA_REQUEST",
});

export const fetchStudentNotificationListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_NOTIFICATION_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentNotificationListDataFailure = (error) => ({
    type: "FETCH_STUDENT_NOTIFICATION_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentNotificationListData = () => async (dispatch) => {
    dispatch(fetchStudentNotificationListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/notification`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentNotificationListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentNotificationListDataFailure(error.message));
    }
}

export const fetchStudentSmallNotificationListDataRequest = () => ({
    type: "FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_REQUEST",
});

export const fetchStudentSmallNotificationListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentSmallNotificationListDataFailure = (error) => ({
    type: "FETCH_STUDENT_SMALL_NOTIFICATION_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentSmallNotificationListData = () => async (dispatch) => {
    dispatch(fetchStudentSmallNotificationListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/web/notification-list`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentSmallNotificationListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentSmallNotificationListDataFailure(error.message));
    }
}

export const fetchStudentBookedCourseListDataRequest = () => ({
    type: "FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_REQUEST",
});

export const fetchStudentBookedCourseListDataSuccess = (data) => ({
    type: "FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_SUCCESS",
    payload: data,
});

export const fetchStudentBookedCourseListDataFailure = (error) => ({
    type: "FETCH_STUDENT_BOOKED_COURSE_LIST_DATA_FAILURE",
    payload: error,
});

export const getStudentBookedCourseListData = () => async (dispatch) => {
    dispatch(fetchStudentBookedCourseListDataRequest());
    try {
        const authToken = localStorage.getItem('student-token')
        let response = await api.get(`/api/student/booked-course-list`, {
            headers: {
                "x-auth-token": authToken,
            }
        });

        const data = response.data;
        let desired_data = data?.data;

        dispatch(fetchStudentBookedCourseListDataSuccess(desired_data));
    } catch (error) {
        dispatch(fetchStudentBookedCourseListDataFailure(error.message));
    }
}